var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"src":"https://www.api-apsth.co/faceapp/","frameborder":"0","width":"100%","height":"900px"}})])}]

export { render, staticRenderFns }